import { Layout, Row, Col, Image } from "antd";
import footerImg from "../../assets/images/Strategia_logo.svg";
import constants from "../../constants/constants";
import { componentStyles } from "./LayoutStyles";
import { off } from "process";

function Footer() {
  const { Footer: AntFooter } = Layout;

  return (
    <>
     <Row className="just" style={componentStyles.rowWrapper}>
  {/* This Col will be full-width on xs and hidden on sm, but will span 24 columns on larger screens */}
  <Col xs={24} sm={24} md={24} lg={24}>
    <Row
      justify="space-around"
      align="middle"
      gutter={[16, 16]} // Adds some space between columns for better spacing on small screens
    >
      {/* This image will take up more space on smaller screens, but stay smaller on larger screens */}
      <Col
        xs={8}  // Full width on mobile (xs)
        sm={8}   // 6 columns on small screens (sm)
        md={4}   // 4 columns on medium screens (md)
        lg={3}   // 3 columns on large screens (lg)
      >
        <Image
          src={footerImg}
          alt="footer-img"
          preview={false}
          style={{ objectFit: "contain", width: "100%" }} // Ensure image is responsive
        />
      </Col>

      {/* This text block will take full width on mobile, reducing as screen size increases */}
      <Col
        xs={8}   // Full width on mobile
        sm={8}   // 18 columns on small screens
        md={14}   // 14 columns on medium screens
        lg={12}   // 12 columns on large screens
      >
        <Row justify="end" align="middle" style={componentStyles.h100}>
          <span style={componentStyles.fontStyles}>
            {constants.footerSubHeading} <br />
            {constants.footerHeading}
          </span>
        </Row>
      </Col>
    </Row>
  </Col>
</Row>
    </>
  );
}

export default Footer;
